import { vocusMobileServerParamKey } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export enum VocusMobileRouteName {
    ServerShow = 'vocus.mobile.server.show',
    MobileIndex = 'vocus.mobile.index',
    MobileUsageIndex = 'vocus.mobile.usage',
    MobileInvoiceIndex = 'vocus.mobile.invoice.index',
}

export default {
    path: '/vocus-mobile',
    name: 'vocus-mobile.index',
    component: () => import('./views/Index.vue'),
    meta: {
        label: 'Vocus Mobile',
        permission: Permission.VocusMobileServerViewAny,
        auth: true,
    },
    children: [
        {
            path: 'settings',
            name: 'vocus-mobile.settings.index',
            component: () => import('./views/settings/Index.vue'),
            meta: {
                label: 'Settings',
                permission: 'manage-vocus',
            },
            children: [
                {
                    path: 'form-schema',
                    name: 'vocus-mobile.settings.form-schema',
                    component: () => import('./views/settings/form-schema/Index.vue'),
                    meta: {
                        label: 'Form Schema',
                        permission: 'manage-vocus',
                    },
                    children: [],
                },
            ],
        },
        {
            path: `servers/:${vocusMobileServerParamKey}`,
            name: VocusMobileRouteName.ServerShow,
            component: () => import('./views/server/Show.vue'),
            meta: {
                label: 'Server',
            },
            children: [
                {
                    path: 'mobiles',
                    name: VocusMobileRouteName.MobileIndex,
                    component: () => import('./views/server/mobile/Index.vue'),
                    meta: {
                        label: 'Mobiles',
                        permission: Permission.VocusMobileViewAny,
                    },
                    children: [
                        {
                            path: 'create',
                            name: 'vocus-mobile.server.mobiles.create',
                            component: () => import('./views/server/mobile/Index.vue'),
                            meta: {
                                label: 'Create',
                                icon: 'fal fa-mobile fa-fw',
                                permission: 'manage-vocus',
                            },
                        },
                        {
                            path: 'port-in',
                            name: 'vocus-mobile.server.mobiles.port-in',
                            component: () => import('./views/server/mobile/Index.vue'),
                            meta: {
                                label: 'Port In',
                                icon: 'fal fa-mobile fa-fw',
                                permission: 'manage-vocus',
                            },
                        },
                        {
                            path: 'check-sim',
                            name: 'vocus-mobile.server.mobiles.check-sim',
                            component: () => import('./views/server/mobile/Index.vue'),
                            meta: {
                                label: 'Check SIM',
                                icon: 'fal fa-mobile fa-fw',
                                permission: 'manage-vocus',
                            },
                        },
                        {
                            path: ':mobileId/edit',
                            name: 'vocus-mobile.server.mobiles.edit',
                            component: () => import('./views/server/mobile/Index.vue'),
                            meta: {
                                label: 'Edit Mobile',
                                icon: 'fal fa-mobile fa-fw',
                                permission: 'manage-vocus',
                            },
                        },
                        {
                            path: ':mobileId/manage-features',
                            name: 'vocus-mobile.server.mobiles.manage-features',
                            component: () => import('./views/server/mobile/Index.vue'),
                            meta: {
                                label: 'Manage Features',
                                icon: 'fal fa-mobile fa-fw',
                                permission: 'manage-vocus',
                            },
                        },
                        {
                            path: ':mobileId/swap-sim',
                            name: 'vocus-mobile.server.mobiles.swap-sim',
                            component: () => import('./views/server/mobile/Index.vue'),
                            meta: {
                                label: 'Swap SIM',
                                icon: 'fal fa-mobile fa-fw',
                                permission: 'manage-vocus',
                            },
                        },
                    ],
                },
                {
                    path: 'usage',
                    name: VocusMobileRouteName.MobileUsageIndex,
                    component: () => import('./views/server/usage/Index.vue'),
                    meta: {
                        label: 'Usage',
                        permission: Permission.VocusMobileUsageViewAny,
                    },
                },
                {
                    path: 'invoices',
                    name: VocusMobileRouteName.MobileInvoiceIndex,
                    component: () => import('./views/server/invoice/Index.vue'),
                    meta: {
                        label: 'Invoices',
                        permission: 'manage-vocus',
                    },
                },
            ],
        },
    ],
}
